import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { JobsComponent } from './jobs/jobs.component';
import { JobComponent } from './jobs/job/job.component';
import { MpjobComponent } from './jobs/mpjob/mpjob.component';
import { ClientsComponent } from './clients/clients.component';
import { ClientDashboardComponent } from './clients/client-dashboard/client-dashboard.component';
import { SingleClientComponent } from './clients/single-client/single-client.component';
import { LoginComponent } from './login/login.component';
import { SubmissionComponent } from './submission/submission.component';
import { InstructorSubmissionComponent } from './submission/instructor-submission/instructor-submission.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AssignmentStatusComponent } from './courses/assignment-status/assignment-status.component';
import { ProfileComponent } from './commons/profile/profile.component';
import { NewFileModalComponent } from './files/new-file-modal/new-file-modal.component';
import { AuthGuard } from './auth.guard';
import { ModuleGuard } from './permission.guard';
import { Role } from './_models/role';
import { Permission } from './_models/permission';
import { AddJobModalComponent } from './jobs/add-job-modal/add-job-modal.component';
import { EditJobModalComponent } from './jobs/edit-job-modal/edit-job-modal.component';
import { AddMpJobComponent } from './jobs/add-mp-job/add-mp-job.component';
import { EditMpJobComponent } from './jobs/edit-mp-job/edit-mp-job.component'
import { ServerErrorComponent } from './server-error/server-error.component';
import { FileTileComponent } from './commons/file-tile/file-tile.component';
import { InductionRecordsComponent } from './induction/induction-records/induction-records.component';
import { VideoPreviewComponent } from './commons/video-preview/video-preview.component';
import { SessionsComponent } from './portfolio/sessions/sessions.component';
import { NotificationComponent } from './notification/notification.component';
import { AssessmentPlanGymComponent } from './portfolio/assessment-plan-gym/assessment-plan-gym.component';
import { EditClientModalComponent } from './clients/edit-client-modal/edit-client-modal.component';


// IMPORT NEW MODULE STRUCTURE COMPONENTS

import { MainJobModule } from './jobs/main-job/main-job.module';
import { AuthGuardLazyLoad } from './authlazyload.guard';
import { DigitalCardComponent } from './digital-card/digital-card.component';
import { MultiJobListComponent } from './multi-job-list/multi-job-list.component';
import { MultipleUserListComponent } from './multiple-user-list/multiple-user-list.component';
import { SponsorPackComponent } from './induction/sponsor-pack/sponsor-pack.component';
// import { SponsorPackComponent } from './induction/sponsor-pack/sponsor-pack.component';
import { SponsorPackV2Component } from './induction/sponsor-pack-v2/sponsor-pack-v2.component';



const routes: Routes = [
	{
		path: '',
		redirectTo: "login/admin",
		pathMatch: "full",
		// component: LoginComponent
	},
	{
		path: 'dashboard',
		component: DashboardComponent,
		canActivate: [AuthGuard],
		data: { roles: [Role.Admin, Role.Manager], permission: [Permission.TrainingJob, Permission.MpJob] },
	},
	{
		path: 'submission',
		component: SubmissionComponent,
		canActivate: [AuthGuard, ModuleGuard],
		data: { roles: [Role.Admin, Role.Trainer, Role.Mp, Role.IQA], permission: [Permission.TrainingJob] }
	},
	{
		path: 'submission/learner/:id',
		component: InstructorSubmissionComponent,
		canActivate: [AuthGuard],
	},
	{
		path: 'login/admin',
		component: LoginComponent,
		// canActivate: [AuthGuard]
	},
	{
		path: 'login',
		component: LoginComponent,
		// canActivate: [AuthGuard]
	},
	{
		path: 'forgotpassword/:user',
		component: ForgotpasswordComponent
	},
	{
		path: 'resetpassword/:user',
		component: ResetPasswordComponent,
		canActivate: [AuthGuard],
	},
	{
		path: 'resetpassword',
		component: ResetPasswordComponent,
		// canActivate: [AuthGuard],
	},
	{
		path: 'assignment/status/:jobid',
		component: AssignmentStatusComponent,
		canActivate: [AuthGuard],
	},
	{
		path: 'profile',
		component: ProfileComponent
	},
	{
		path: 'newFile',
		component: NewFileModalComponent
	},
	{
		path: 'fileTile',
		component: FileTileComponent
	},
	{
		path: 'server-error',
		component: ServerErrorComponent
	},
	{
		path: 'session',
		component: SessionsComponent
	},
	{
		path: 'induction',
		component: InductionRecordsComponent,
		canActivate: [AuthGuard, ModuleGuard],
		data: { roles: [Role.Admin], permission: [Permission.Inductions] }
	},
	{
		path: 'video-preview/:path',
		component: VideoPreviewComponent,
	},
	{
		path: 'notification',
		component: NotificationComponent,
	},
	{
		path: 'login/super-admin',
		component: LoginComponent
	},
	{
		path: 'accident',
		canActivate: [AuthGuard, ModuleGuard],
		data: { permission: [Permission.Accident] },
		loadChildren: () => import('./accident/accident.module').then(m => m.AccidentModule),
		canLoad: [AuthGuardLazyLoad],
	},
	{
		path: 'asset',
		canActivate: [AuthGuard, ModuleGuard],
		data: { permission: [Permission.Asset] },
		loadChildren: () => import('./asset/asset.module').then(m => m.AssetModule),
		canLoad: [AuthGuardLazyLoad]
	},
	{
		path: 'competency',
		canActivate: [AuthGuard],
		// data: { permission: [Permission.Asset] },
		loadChildren: () => import('./competency/competency.module').then(m => m.CompetencyModule),
		canLoad: [AuthGuardLazyLoad]
	},
	{
		path: 'plan',
		component: AssessmentPlanGymComponent
	},

	{
		path: 'digital-card/:id',
		component: DigitalCardComponent
	},

	{
		path: 'sponsor-pack',
		// component: SponsorPackComponent
		component: SponsorPackV2Component
	},

	// JOB MODULE ROUTE 
	{
		path: 'job',
		canActivate: [AuthGuard, ModuleGuard],
		data: { permission: [Permission.TrainingJob] },
		loadChildren: () => import('./jobs/main-job/main-job.module').then(m => m.MainJobModule),
		canLoad: [AuthGuardLazyLoad]
	},

	{
		path: 'client',
		canActivate: [AuthGuard, ModuleGuard],
		data: { permission: [Permission.Client] },
		loadChildren: () => import('./clients/main-client/main-client.module').then(m => m.MainClientModule),
		canLoad: [AuthGuardLazyLoad]
	},

	{
		path: 'course',
		canActivate: [AuthGuard, ModuleGuard],
		data: { permission: [Permission.TrainingJob] },
		loadChildren: () => import('./courses/main-course/main-course.module').then(m => m.MainCourseModule),
		canLoad: [AuthGuardLazyLoad]
	},
	{
		path: 'jobDoc',
		canActivate: [AuthGuard, ModuleGuard],
		data: { permission: [Permission.TrainingJob] },
		loadChildren: () => import('./documents/main-document/main-document.module').then(m => m.MainDocumentModule),
		canLoad: [AuthGuardLazyLoad]
	},

	// MY DOCUMENTS MODULE ROUTE
	{
		path: 'mydocuments',
		canActivate: [AuthGuard, ModuleGuard],
		data: { permission: [Permission.MyDocs] },
		loadChildren: () => import('./folder/main-folder-module/main-folder.module').then(m => m.MainFolderModuleModule),
		canLoad: [AuthGuardLazyLoad]
	},

	// LEARNE DOCUMENT MODULE ROUTE
	{
		path: 'learner',
		canActivate: [AuthGuard, ModuleGuard],
		data: { permission: [Permission.TrainingJob] },
		loadChildren: () => import('./learners/main-learner/main-learner.module').then(m => m.MainLearnerModule),
		canLoad: [AuthGuardLazyLoad]
	},

	{
		path: 'learner',
		canActivate: [AuthGuard, ModuleGuard],
		data: { permission: [Permission.TrainingJob] },
		loadChildren: () => import('./portfolio/main-portfolio/main-portfolio.module').then(m => m.MainPortfolioModule),
		canLoad: [AuthGuardLazyLoad]
	},

	// MEDICAL FORM MODULE ROUTE

	{
		path: 'medical-record',
		canActivate: [AuthGuard, ModuleGuard],
		data: { permission: [Permission.MpJob] },
		loadChildren: () => import('./medical/main-medical/main-medical.module').then(m => m.MainMedicalModule),
		canLoad: [AuthGuardLazyLoad]
	},


	// QUIZ MODULE ROUTE

	{
		path: 'quiz',
		canActivate: [AuthGuard, ModuleGuard],
		data: { permission: [Permission.MpJob, Permission.TrainingJob] },
		loadChildren: () => import('./quiz/main-quiz/main-quiz.module').then(m => m.MainQuizModule),
		canLoad: [AuthGuardLazyLoad]
	},

	// SCHEDULER MODULE ROUTE

	{
		path: 'scheduler',
		canActivate: [AuthGuard],
		// data: { permission: [Permission.MpJob] },
		loadChildren: () => import('./scheduler/main-scheduler/main-scheduler.module').then(m => m.MainSchedulerModule),
		canLoad: [AuthGuardLazyLoad]
	},
	{
		path: 'labour-job',
		canActivate: [AuthGuard, ModuleGuard],
		data: { permission: [Permission.LabourJob] },
		loadChildren: () => import('./labour-job/labour-job/labour-job.module').then(m => m.LabourJobModule)
	},
	{
		path: 'staff',
		canActivate: [AuthGuard, ModuleGuard],
		data: { permission: [Permission.Staff] },
		loadChildren: () => import('./staff/main-staff/main-staff.module').then(m => m.MainStaffModule),
		canLoad: [AuthGuardLazyLoad]
	},
	// TIME-SHEET MODULE ROUTE
	{
		path: 'timesheet',
		canActivate: [AuthGuard, ModuleGuard],
		data: { permission: [Permission.Timesheet] },
		loadChildren: () => import('./time-sheet/main-timesheet/main-timesheet.module').then(m => m.MainTimesheetModule),
		canLoad: [AuthGuardLazyLoad]
	},
	{
		path: 'multi-job-list',
		canActivate: [AuthGuard, ModuleGuard],
		data: { permission: [Permission.TrainingJob, Permission.LabourJob] },
		component: MultiJobListComponent
	},
	{
		path: 'users',
		canActivate: [AuthGuard, ModuleGuard],
		data: { permission: [Permission.TrainingJob, Permission.LabourJob] },
		component: MultipleUserListComponent
	},
	{
		path: 'fixed-asset',
		canActivate: [AuthGuard],
		// data: { permission: [Permission.Asset] },
		loadChildren: () => import('./fixed-asset/fixed-asset.module').then(m => m.FixedAssetModule)
	},

	{
		path: 'plant-asset',
		canActivate: [AuthGuard],
		// data: { permission: [Permission.Asset] },
		loadChildren: () => import('./plant-asset/plant-asset.module').then(m => m.PlantAssetModule)
	},

	// FORM DIGITIZATION MODULE
	{
		path: 'forms',
		canActivate: [AuthGuard],
		loadChildren: () => import('./form-digitization/form-digitization/form-digitization.module').then(m => m.FormDigitizationModule),
		canLoad: [AuthGuardLazyLoad]
	},
];


@NgModule({
	imports: [
		RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
	],
	exports: [RouterModule]
})
export class AppRoutingModule { }

